import { createSelector } from 'reselect';
import { cashierTransactionReducer, CashierTransactionSliceType } from './cashier.reducer';

export const cashierTransactionSliceSelector = (state: any): any => state[cashierTransactionReducer.sliceName];

export const isLoadingSliceSelector = createSelector(
  cashierTransactionSliceSelector,
  (cashierTransactionSlice: CashierTransactionSliceType) => cashierTransactionSlice.isLoading,
);

export const IsLoadingCreateTransactionSliceSelector = createSelector(
  cashierTransactionSliceSelector,
  (cashierTransactionSlice: CashierTransactionSliceType) => cashierTransactionSlice.isLoadingCreateTransaction,
);

export const IsLoadingValidateUseWithdrawalCodeSliceSelector = createSelector(
  cashierTransactionSliceSelector,
  (cashierTransactionSlice: CashierTransactionSliceType) => cashierTransactionSlice.isLoadingValidateUseWithdrawalCode,
);

export const isSavingSliceSelector = createSelector(
  cashierTransactionSliceSelector,
  (cashierTransactionSlice: CashierTransactionSliceType) => cashierTransactionSlice.isSaving,
);

export const typeSelector = createSelector(
  cashierTransactionSliceSelector,
  (cashierTransactionSlice: CashierTransactionSliceType) => cashierTransactionSlice.type,
);

export const methodSelector = createSelector(
  cashierTransactionSliceSelector,
  (cashierTransactionSlice: CashierTransactionSliceType) => cashierTransactionSlice.method,
);

export const bonusSelector = createSelector(
  cashierTransactionSliceSelector,
  (cashierTransactionSlice: CashierTransactionSliceType) => cashierTransactionSlice.bonus,
);

export const playerNumberSelector = createSelector(
  cashierTransactionSliceSelector,
  (cashierTransactionSlice: CashierTransactionSliceType) => cashierTransactionSlice.player_number,
);

export const accountSelector = createSelector(
  cashierTransactionSliceSelector,
  (cashierTransactionSlice: CashierTransactionSliceType) => cashierTransactionSlice.account,
);

export const amountSelector = createSelector(
  cashierTransactionSliceSelector,
  (cashierTransactionSlice: CashierTransactionSliceType) => cashierTransactionSlice.amount,
);

export const nameSelector = createSelector(
  cashierTransactionSliceSelector,
  (cashierTransactionSlice: CashierTransactionSliceType) => cashierTransactionSlice.name,
);

export const fingerprintSelector = createSelector(
  cashierTransactionSliceSelector,
  (cashierTransactionSlice: CashierTransactionSliceType) => cashierTransactionSlice.fingerprint,
);

export const ipSelector = createSelector(
  cashierTransactionSliceSelector,
  (cashierTransactionSlice: CashierTransactionSliceType) => cashierTransactionSlice.ip,
);

export const transactionSelector = createSelector(
  cashierTransactionSliceSelector,
  (cashierTransactionSlice: CashierTransactionSliceType) => cashierTransactionSlice.transaction,
);

export const isTransactionSuccessSelector = createSelector(
  cashierTransactionSliceSelector,
  (cashierTransactionSlice: CashierTransactionSliceType) => cashierTransactionSlice.isTransactionSuccess,
);

export const paymentMethodsSelector = createSelector(
  cashierTransactionSliceSelector,
  (cashierTransactionSlice: CashierTransactionSliceType) => cashierTransactionSlice.paymentMethods,
);

export const availableBonusesSelector = createSelector(
  cashierTransactionSliceSelector,
  (cashierTransactionSlice: CashierTransactionSliceType) => cashierTransactionSlice.availableBonuses,
);

export const transactionStatusSelector = createSelector(
  cashierTransactionSliceSelector,
  (cashierTransactionSlice: CashierTransactionSliceType) => cashierTransactionSlice.transactionStatus,
);

export const cbioAllowedSelector = createSelector(
  cashierTransactionSliceSelector,
  (cashierTransactionSlice: CashierTransactionSliceType) => cashierTransactionSlice.cbioAllowed,
);

export const smsCodeCheckSelector = createSelector(
  cashierTransactionSliceSelector,
  (cashierTransactionSlice: CashierTransactionSliceType) => cashierTransactionSlice.smsCodeCheck,
);

export const checkSmsCodeResponseSelector = createSelector(
  cashierTransactionSliceSelector,
  (cashierTransactionSlice: CashierTransactionSliceType) => cashierTransactionSlice.checkSmsCodeResponse,
);

export const freeFreeTimesSelector = createSelector(
  cashierTransactionSliceSelector,
  (cashierTransactionSlice: CashierTransactionSliceType) => cashierTransactionSlice.feeFreeTime,
);

export const playerBanksSelector = createSelector(
  cashierTransactionSliceSelector,
  (cashierTransactionSlice: CashierTransactionSliceType) => cashierTransactionSlice.playerBanks,
);

export const institutionsSelector = createSelector(
  cashierTransactionSliceSelector,
  (cashierTransactionSlice: CashierTransactionSliceType) => cashierTransactionSlice.institutions,
);

export const mfaChallengeSelector = createSelector(
  cashierTransactionSliceSelector,
  (cashierTransactionSlice: CashierTransactionSliceType) => cashierTransactionSlice.mfa,
);

export const selectableBanksSelector = createSelector(
  cashierTransactionSliceSelector,
  (cashierTransactionSlice: CashierTransactionSliceType) => cashierTransactionSlice.selectableBanks,
);

export const wdHoldAmountSelector = createSelector(
  cashierTransactionSliceSelector,
  (cashierTransactionSlice: CashierTransactionSliceType) => cashierTransactionSlice.wdHoldAmount,
);

export const accountsSelector = createSelector(
  cashierTransactionSliceSelector,
  (cashierTransactionSlice: CashierTransactionSliceType) => cashierTransactionSlice.accounts,
);

export const cashierDialogShowSelector = createSelector(
  cashierTransactionSliceSelector,
  (cashierTransactionSlice: CashierTransactionSliceType) => cashierTransactionSlice.cashierDialog,
);

export const transactionLimitDetailsSelector = createSelector(
  cashierTransactionSliceSelector,
  (cashierTransactionSlice: CashierTransactionSliceType) => cashierTransactionSlice.transactionLimitDetails,
);

export const PlayerProfileSettingsPaymentMethodBonusesSelector = createSelector(
  cashierTransactionSliceSelector,
  (cashierTransactionSlice: CashierTransactionSliceType) => cashierTransactionSlice.playerProfileSettingsPaymentMethodBonuses,
);

export const isWelcomeBonusSelector = createSelector(
  cashierTransactionSliceSelector,
  (cashierTransactionSlice: CashierTransactionSliceType) => cashierTransactionSlice.isWelcomeBonus,
);

export const UseWithdrawalVerificationCodeSliceSelector = createSelector(
  cashierTransactionSliceSelector,
  (cashierTransactionSlice: CashierTransactionSliceType) => cashierTransactionSlice.useWithdrawalVerificationCode,
);

export const IsLoadingPendingTransactionApprovePurchaseSelector = createSelector(
  cashierTransactionSliceSelector,
  (cashierTransactionSlice: CashierTransactionSliceType) => cashierTransactionSlice.isLoadingPendingTransactionApprovePurchase,
);

export const TransactionApprovePurchaseSelector = createSelector(
  cashierTransactionSliceSelector,
  (cashierTransactionSlice: CashierTransactionSliceType) => cashierTransactionSlice.transaction_approve_purchase,
);

export const IsApprovePurchaseSuccessSelector = createSelector(
  cashierTransactionSliceSelector,
  (cashierTransactionSlice: CashierTransactionSliceType) => cashierTransactionSlice.is_approve_purchase_success,
);

export const sendSmsCodeResponseSelector = createSelector(
  cashierTransactionSliceSelector,
  (cashierTransactionSlice: CashierTransactionSliceType) => cashierTransactionSlice.sendSmsCodeResponse,
);
